module.exports = __webpack_public_path__ + "static/media/2_pl.37af2b5d.png";